import { EventStatus } from './constants.js';
import { createAssociativeTrace } from '../models/trace.js';

export function admitEvent(event, priorTrace, evidenceItem) {
  if (event.reflexOriginated && event.originType === 'REFLEX_SIGNAL') return { admitted: false, reasonCode: 'REFLEX_REQUIRES_EVENT_ADMISSION' };
  const admittedEvent = Object.freeze({ ...event, status: EventStatus.ADMITTED });
  const trace = createAssociativeTrace(priorTrace ? {
    ...priorTrace,
    version: priorTrace.version + 1,
    eventIds: [...priorTrace.eventIds, event.eventId],
    provenanceLedger: [...priorTrace.provenanceLedger, event.provenance],
    evidenceLedger: evidenceItem ? [...priorTrace.evidenceLedger, evidenceItem] : priorTrace.evidenceLedger,
    lineageIds: [...priorTrace.lineageIds, event.lineageId],
    attentionWeight: Math.min(1, priorTrace.attentionWeight + event.salience * 0.08),
    lastUpdatedAt: event.timestamp
  } : {
    traceId: `trace-${event.scenarioId}`, version: 1, eventIds: [event.eventId], representation: event.representation,
    provenanceLedger: [event.provenance], evidenceLedger: evidenceItem ? [evidenceItem] : [], lineageIds: [event.lineageId],
    attentionWeight: event.salience, recallCount: 0, createdAt: event.timestamp, lastUpdatedAt: event.timestamp
  });
  return { admitted: true, event: admittedEvent, trace, reasonCode: priorTrace ? 'ASSOCIATIVE_TRACE_UPDATED' : 'ASSOCIATIVE_TRACE_CREATED' };
}
